var $5a0b3a154dcf111b$exports = {};
$5a0b3a154dcf111b$exports = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};


export {$5a0b3a154dcf111b$exports as default};
//# sourceMappingURL=el-GR.mjs.map
